import { type LeadFormData } from "../LeadAddPage/components/lead-form-data.ts"

/** Every workspace surface writes the lead through this one PATCH shape. */
type LeadWorkspacePatch = Partial<LeadFormData>

/** Resolves to `false` on a rejected save rather than throwing. */
type LeadPatchSender = (patch: LeadWorkspacePatch) => Promise<boolean>

const isBlank = (value: unknown) => value == null || value === ""

const isSameValue = (a: unknown, b: unknown) => {
  if (a === b) return true
  if (isBlank(a) && isBlank(b)) return true
  if (
    typeof a === "object" &&
    typeof b === "object" &&
    a !== null &&
    b !== null
  )
    return JSON.stringify(a) === JSON.stringify(b)
  return false
}

/**
 * Keys are read from `next`, so a caller only ever offers the fields its own
 * surface owns and can never widen the PATCH into someone else's field.
 */
const pickChangedFields = <V extends object>(
  pristine: V,
  next: V
): Partial<V> =>
  (Object.keys(next) as (keyof V)[]).reduce<Partial<V>>((changed, key) => {
    if (!isSameValue(pristine?.[key], next[key])) changed[key] = next[key]
    return changed
  }, {})

export { type LeadWorkspacePatch, type LeadPatchSender, pickChangedFields }
